import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import Modal from 'components/Modal';
import Progress from 'components/Progress';
import { resumeApplication as resumeApplicationAction } from '../../actions/navigation';
import ApplicationId from '../../components/ApplicationId';
import Header from '../../components/Header';
import imgDeclined from '../../assets/images/declined.svg';
import imgError from '../../assets/images/error.svg';

const CreditFreeze = ({ navigate, checkinData, params, searchParams, dispatch }) => {
  const workflowType = get(params, 'workflowType') || 'text2apply';
  const key = searchParams.get('key');
  const [errorMsg, setErrorMsg] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);
  const [isProgressVisible, setIsProgressVisible] = useState(false);

  useEffect(() => {
    if (!get(checkinData, 'data.data')) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    }
  }, []);

  const resumeApplication = () => {
    setIsProgressVisible(true);
    dispatch(resumeApplicationAction({
      key,
      activity: 'continuefromcreditfreeze',
      workflowType,
      success: (res) => {
        setIsProgressVisible(false);
        const route = get(res, 'state.url', get(res, 'data.url'));
        if (route) {
          navigate(route);
        }
      },
      fail: (error) => {
        setIsProgressVisible(false);
        setIsPopupVisible(true);
        if (error?.response?.data && error.response.data.errorMessages && error?.response?.data.errorMessages.length > 0) {
          setErrorMsg(error.response.data.errorMessages[0]);
        }
        console.log('error', error);
      },
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
    setErrorMsg('');
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <div className="content appIdVisible">
        <img src={imgDeclined} alt="Declined" width="100px" />
        <h1>Your Credit Is Frozen</h1>
        <p style={{ marginBottom: 0 }}>The following actions are needed so that a decision can be made on your application:</p>
        <b style={{ fontWeight: 'bold' }}>
          To remove the freeze from your credit report, please visit the
          {' '}
          <a target="_blank" rel="noopener noreferrer" href="https://service.transunion.com/dss/login.page?">TransUnion Service Center</a>
          {' '}
          or call TransUnion at
          {' '}
          <a href="tel:+18889098872">888-909-8872</a>
          .
        </b>
        <b style={{ fontWeight: 'bold' }}>
          After the removal of the credit freeze, please click on this
          {' '}
          {/* eslint-disable-next-line */}
          <a href="#" onClick={resumeApplication}>link</a>
          {' '}
          to continue your application.
        </b>
        <hr />
        <p>You must complete the above actions within 30 days; otherwise, we will be unable to proceed with this credit application.</p>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <a href="tel:+18009946177" className="btn btn-primary">Contact Us</a>
          </div>
        </div>
      </div>
      {
        isPopupVisible && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>{errorMsg || 'Please try again.'}</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
        )
      }
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

CreditFreeze.propTypes = {
  navigate: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(CreditFreeze);
